import React from "react";
import "./UiTooltip.css";
import { useState } from "react";
import { useEffect, useRef } from "react";

function UiTooltip({
  content = "",
  children,
  position = "top",
  style,
  className,
  ...props
}) {
  const [visible, setVisible] = useState(false);
  const tooltipRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
        setVisible(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <React.Fragment>
      <div
        className={`ui-tooltip-container ${className || ""}`}
        ref={tooltipRef}
      >
        <div style={style} onMouseEnter={() => setVisible(true)}
           {...props}>
          {children}
        </div>
        <div
          className={`ui-tooltip-box ui-tooltip-${position} ${visible ? "ui-tooltip-box-visible" : ""
            }`}
        >
          {content}
        </div>
      </div>
    </React.Fragment>
  );
}

export default UiTooltip;
